export default __webpack_public_path__ + "static/media/logo-horizontal.2b2d192f.png";